import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { PROSTHESIS_ATTACHMENT_CHANNELS, PROSTHESIS_ATTACHMENT_CHANNELS_FEATURED_COUNT } from "@bookdental/schemas";
import { cn } from "@/lib/cn";

type Props = {
  value: string[];
  onChange: (channels: string[]) => void;
};

const FEATURED = PROSTHESIS_ATTACHMENT_CHANNELS.slice(0, PROSTHESIS_ATTACHMENT_CHANNELS_FEATURED_COUNT);
const REST = PROSTHESIS_ATTACHMENT_CHANNELS.slice(PROSTHESIS_ATTACHMENT_CHANNELS_FEATURED_COUNT);

/** Múltipla escolha de "por onde esse anexo foi enviado fora da plataforma" — 4 chips mais usados
 *  sempre visíveis, resto atrás de "Mostrar mais". */
export function AttachmentChannelPicker({ value, onChange }: Props) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? PROSTHESIS_ATTACHMENT_CHANNELS : FEATURED;

  const toggle = (channel: string) => {
    onChange(value.includes(channel) ? value.filter((c) => c !== channel) : [...value, channel]);
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {visible.map((channel) => {
        const active = value.includes(channel);
        return (
          <button
            key={channel}
            type="button"
            onClick={() => toggle(channel)}
            className={cn(
              "inline-flex h-7 items-center rounded-full border px-2.5 text-[11.5px] font-medium transition-colors",
              active
                ? "border-brand-600 bg-brand-600 text-white"
                : "border-zinc-200 bg-white text-zinc-600 hover:border-brand-300 hover:text-brand-700 dark:border-border dark:bg-card dark:text-muted-foreground",
            )}
          >
            {channel}
          </button>
        );
      })}
      {REST.length > 0 && (
        <button
          type="button"
          onClick={() => setExpanded((e) => !e)}
          className="inline-flex h-7 items-center gap-1 rounded-full px-2.5 text-[11.5px] font-medium text-zinc-500 hover:text-brand-700 dark:text-muted-foreground"
        >
          {expanded ? "Mostrar menos" : "Mostrar mais"}
          {expanded ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
        </button>
      )}
    </div>
  );
}
